import { Modal } from "antd-mobile";
import defaultImg from "assets/images/default.jpg";
import { getStorage, navigateTo } from 'common/util';
import moment from "moment";
import qs from "qs";
import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import HistoryMenu from "./HistoryMenu";
import BacklogMenu from "./backlogMenu";
import './index.less';
import List from './list';

const wx = window.wx || {};

export default class Home extends Component {
    constructor(props) {
        super(props);
        this.state = {
            currentIndex: 1, // 默认给出初始进入页面时当前页面为“待办”页
            offsetTopHeight: 0, // 当前ref所操作DOM元素距离浏览器上方之间的高度
            show: false, // 用于tab展示
            carrierData: null, // 获取菜单页的承运商的数据
            btext: "车牌号、派车单号、装货单位、卸货单位", // 默认input框中的值
            htext: "车牌号、派车单号、装货单位、卸货单位", // 默认input框中的值
            bstartDate: null, // 待办页筛选条件的起始日期
            bendDate: null, // 待办页筛选条件的结束日期
            bcarrierListData: [], // 待办页筛选条件的承运商
            hstartDate: null, // 历史页筛选条件的起始日期
            hendDate: null, // 历史页筛选条件的结束日期
            hcarrierListData: [], // 历史页筛选条件的承运商
            fstatusflag: null, // 历史页筛选条件的状态
            imgUrl: null,
            phoneNumber: '',
            modal: false,
            switchBFilterIcon: false, // 用于当待办出现筛选条件时图标的变化
            switchHFilterIcon: false, // 用于当历史出现筛选条件时图标的变化
        };
    }


    tabs = [
        { tabName: "待办订单", id: 1 },
        { tabName: "历史订单", id: 2 }
    ]


    // tab切换的方法
    tabChoiced = id => {
        this.setState({
            currentIndex: id,
        }, () => {
            this.bchild.handleMenu();
            this.hchild.handleMenu();
        });
    }

    // 是否展示筛选条件菜单
    showMenu = () => {
        this.setState({
            show: !this.state.show,
        }, () => {
            this.bchild.handleMenu();
            this.hchild.handleMenu();
        })
    }

    // 打开退出当前帐号的一个模态框
    openModal = e => {
        e.preventDefault();
        this.setState({
            modal: true
        })
    }

    // 关闭模态框
    onClose = () => {
        this.setState({
            modal: false
        })
    }

    // 退出当前账号
    onquit = () => {
        // wx.miniProgram.postMessage({ data: "clearStorage" });

        wx.miniProgram.redirectTo({ url: `../login/index` });
        wx.miniProgram.redirectTo({ url: `../login/index?action=clear` }); // 退出时，打上清空缓存标识
    }

    loginWx = () => {
        wx.miniProgram.postMessage({ data: "clearStorage" });
        // wx.miniProgram.redirectTo({ url: `../login/index` });
        wx.miniProgram.redirectTo({ url: `../login/index?action=loginWx` }); // 退出时，打上清空缓存标识
        // let getUrl = currentPage => {
        //     currentPage = currentPage || ''
        //     return `/login${currentPage}?action=loginWx`
        // }
        // navigateTo({
        //     path: getUrl(),
        //     url: `/pages${getUrl('/index')}`,
        // })
    }

    // input框获取焦点的时候进行一个页面跳转，跳转到搜索页
    pageTo = () => {
        const { currentIndex } = this.state;
        this.setState({
            show: false
        });
        let getUrl = currentPage => {
            currentPage = currentPage || ''
            return `/search${currentPage}?currentIndex=${currentIndex}`
        }
        navigateTo({
            path: getUrl(),
            url: `/pages${getUrl('/index')}`,
        })
    }

    // 用于关闭 待办页 菜单同时存储筛选条件的信息
    getBacklogSubmitStatus = (status, startDate, endDate, carrierListData) => {
        if (status === "backlogReset") {
            this.setState({
                show: true
            })
        } else {
            this.setState({
                show: false
            })
        }
        if (startDate || endDate || carrierListData.length !== 0) {
            this.setState({
                switchBFilterIcon: true
            })
        } else {
            this.setState({
                switchBFilterIcon: false
            })
        }
        this.setState({
            bstartDate: startDate,
            bendDate: endDate,
            bcarrierListData: carrierListData
        })
    }

    // 用于关闭 历史页 菜单同时存储筛选条件的信息
    getHistorySubmitStatus = (status, startDate, endDate, carrierListData, fstatusflag) => {
        if (status === "historyReset") {
            this.setState({
                show: true
            })
        } else {
            this.setState({
                show: false
            })
        }
        if (startDate || endDate || carrierListData.length !== 0 || fstatusflag.toString()) {
            this.setState({
                switchHFilterIcon: true
            })
        } else {
            this.setState({
                switchHFilterIcon: false
            })
        }
        this.setState({
            hstartDate: startDate,
            hendDate: endDate,
            hcarrierListData: carrierListData,
            fstatusflag: fstatusflag === 0 || fstatusflag === 1 ? fstatusflag : null
        });
    }


    zentDidUpdate(prevProps, prevState) {
        let bres = getStorage("backlogInputText");
        let bt = ReactDOM.findDOMNode(this.bt);
        let ht = ReactDOM.findDOMNode(this.ht);
        if (bres) {
            if (bres !== this.state.btext) {
                this.setState({
                    btext: bres
                })
            }
            bt.style.color = '#111111';
        } else {
            bres = "车牌号、派车单号、装货单位、卸货单位"; //这里是当从缓存中拿到的值是null的时候给的默认值
            if (bres !== this.state.btext) {
                this.setState({
                    btext: bres
                })
            }
            bt.style.color = '#BFBFBF';
        }
        let hres = getStorage("historyInputText");
        if (hres) {
            if (hres !== this.state.htext) {
                this.setState({
                    htext: hres
                })
            }
            ht.style.color = '#111111';
        } else {
            hres = "车牌号、派车单号、装货单位、卸货单位"; //这里是当从缓存中拿到的值是null的时候给的默认值
            if (hres !== this.state.htext) {
                this.setState({
                    htext: hres
                })
            }
            ht.style.color = '#BFBFBF';
        }
    }



    componentDidMount() {
        // removeStorage("backlogInputText");
        // removeStorage("historyInputText");
        window.addEventListener("storage", () => {
            this.forceUpdate();
        })

        let offsetTopHeight = ReactDOM.findDOMNode(this.lv).offsetTop; // 获取当前所操作的DOM距离浏览器上方的高度
        let value = this.props.location.search.replace(/^\?/, '') || window.location.search.replace(/^\?/, '') ;
        let countdown = 10;
        const { headPicture, phoneNumber } = qs.parse(value);
        // let avatarUrl = (headPicture && headPicture === 'undefined') ? headPicture : defaultImg ;
        let avatarUrl = headPicture ? headPicture : defaultImg;

        this.setState({
            offsetTopHeight,
            imgUrl: avatarUrl,
            phoneNumber,
            hres: "车牌号、派车单号、装货单位、卸货单位",
            bres: "车牌号、派车单号、装货单位、卸货单位",
            countdown
        });

        let params = {
            action: "22",
            appid: "",
            param: {}
        }
        // let result = getCarrierData(params);
        // result.then( res =>{
        //     if(res){
        //         let carrierData = res.datas.queryresults;
        //         this.setState({
        //             carrierData
        //         })
        //     }
        // })
    }

    componentWillUnmount() {
        window.removeEventListener("storage", () => {
            this.forceUpdate();
        })

    }
    componentWillMount() {
        let value = this.props.location.search.replace(/^\?/, '') || window.location.search.replace(/^\?/, '');
        const { phoneNumber } = qs.parse(value);
        this.setState({
            phoneNumber: phoneNumber
        })
    }

    render() {
        const {
            modal,
            phoneNumber,
            carrierData,
            offsetTopHeight,
            currentIndex,
            show,
            btext,
            htext,
            bstartDate,
            bendDate,
            bcarrierListData,
            hstartDate,
            hendDate,
            hcarrierListData,
            fstatusflag,
            refresh,
            imgUrl,
            switchBFilterIcon,
            switchHFilterIcon,

        } = this.state;
        let _this = this;
        let isBox1Show = currentIndex === 1 ? 'block' : 'none';
        let isBox2Show = currentIndex === 2 ? 'block' : 'none';
        let showView = show ? "block" : "none";
        console.log(phoneNumber, '----------------------------------phoneNumber');
        let bconcatnames = btext === "车牌号、派车单号、装货单位、卸货单位" ? "" : btext;
        let hconcatnames = htext === "车牌号、派车单号、装货单位、卸货单位" ? "" : htext;

        let bbegindate = bstartDate ? moment(bstartDate).format("YYYY-MM-DD") : "";
        let benddate = bendDate ? moment(bendDate).format("YYYY-MM-DD") : "";
        // let hbegindate = hstartDate ? moment(hstartDate).format("YYYY-MM-DD") : moment(new Date(Date.now()-29*24*60*60*1000)).format("YYYY-MM-DD");
        // let henddate = hendDate ? moment(hendDate).format("YYYY-MM-DD") : moment(new Date(Date.now())).format("YYYY-MM-DD");
        let hbegindate = hstartDate ? moment(hstartDate).format("YYYY-MM-DD") : '';
        let henddate = hendDate ? moment(hendDate).format("YYYY-MM-DD") : '';

        let tabList = this.tabs.map((res, index) => {
            // 遍历标签页，如果标签的id等于tabid，那么该标签就加多一个active的className
            let tabStyle = res.id === currentIndex ? 'tabCtrl tab-active active' : 'tabCtrl';
            let underlineStyle = res.id === currentIndex ? 'tab-underline active' : 'tab-underline underline-fade';

            return <div key={index} className="tab-contanier" onClick={this.tabChoiced.bind(_this, res.id)}>
                <div className={tabStyle}>{res.tabName}</div>
                <div className={underlineStyle}></div>
            </div>
        });
        return (
            <div>
                <Modal
                    visible={modal}
                    transparent
                    maskClosable={false}
                    onClose={this.onClose}
                    footer={[{ text: "取消", onPress: () => { this.onClose() } }, { text: "确定", onPress: () => { this.onquit() } }]}
                >
                    {
                        //(phoneNumber && phoneNumber === 'undefined')
                        phoneNumber
                            ? <div><div>当前账号：{phoneNumber}</div><div>确定要退出当前账号嘛？</div></div>
                            : <div><div>当前账号未登录</div><div>请您授权登录后使用</div></div>
                    }
                </Modal>
                <div style={{ position: "relative" }}>
                    <div className="home-page-top">
                        <div className="home-page-top-tab">
                            {tabList}
                        </div>
                        {phoneNumber ? '' : <div
                            style={{
                                display: 'flex',
                                height: '40px',
                                alignItems: 'center',
                                justifyContent: 'space-between',
                                padding: '0 55px',
                                background: 'rgb(249 164 8 / 70%)',
                                color: '#fff',
                                marginTop: '5px'
                            }}
                        >我的订单<a style={{ color: '#fff' }} onClick={() => { this.loginWx() }}>查询&gt;</a></div>}
                        <div className="tab-search" style={{ display: isBox1Show }}>
                            <span className="tab-search-img"></span>
                            <div onClick={this.pageTo} className="tab-search-input">
                                <div className="tab-search-input-text" ref={el => this.bt = el}>{btext}</div>
                            </div>
                            {
                                switchBFilterIcon
                                    ? <span className="tab-search-filter-y" onClick={this.showMenu} ></span>
                                    : <span className="tab-search-filter" onClick={this.showMenu} ></span>
                            }
                        </div>
                        <div className="tab-search" style={{ display: isBox2Show }}>
                            <span className="tab-search-img"></span>
                            <div onClick={this.pageTo} className="tab-search-input">
                                <div className="tab-search-input-text" ref={el => this.ht = el}>{htext}</div>
                            </div>
                            {
                                switchHFilterIcon
                                    ? <span className="tab-search-filter-y" onClick={this.showMenu} ></span>
                                    : <span className="tab-search-filter" onClick={this.showMenu} ></span>
                            }
                        </div>
                        <div style={{ height: "0.02rem", width: "7.5rem" }}></div>
                    </div>
                    <div style={{ display: isBox1Show }}>
                        <BacklogMenu
                            showView={show}
                            carrierData={carrierData}
                            type={'backlog'}
                            onRef={ref => this.bchild = ref}
                            getBacklogSubmitStatus={this.getBacklogSubmitStatus}
                        />
                    </div>
                    <div style={{ display: isBox2Show }}>
                        <HistoryMenu
                            showView={show}
                            carrierData={carrierData}
                            type={'history'}
                            onRef={ref => this.hchild = ref}
                            getHistorySubmitStatus={this.getHistorySubmitStatus}
                        />
                    </div>
                    <div className="home-page-mask" style={{ display: showView }} onClick={this.showMenu}></div>
                    <div className="home-page-headPicture" onClick={this.openModal}>
                        <img src={imgUrl}></img>
                    </div>
                    <div className="home-page-body">
                        <div className="home-page-body-list">
                            <div ref={el => this.lv = el}>
                                <div style={{ display: isBox1Show }}>
                                    {/* 这里加type的目的是为了区分渲染的列表是待办还是历史 */}
                                    <List
                                        {...this.props}
                                        type={'backlog'}
                                        offsetTopHeight={offsetTopHeight}
                                        getList={this.getList}
                                        concatnames={bconcatnames}
                                        begindate={bbegindate}
                                        enddate={benddate}
                                        pk_carriers={bcarrierListData}
                                        refresh={refresh}
                                    >
                                    </List>
                                </div>
                                <div style={{ display: isBox2Show }}>
                                    <List
                                        {...this.props}
                                        type={'history'}
                                        offsetTopHeight={offsetTopHeight}
                                        getList={this.getList}
                                        concatnames={hconcatnames}
                                        fstatusflag={fstatusflag}
                                        begindate={hbegindate}
                                        enddate={henddate}
                                        pk_carriers={hcarrierListData}
                                        refresh={refresh}
                                    >
                                    </List>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div >
        )
    }
}
